export default "__VITE_ASSET__CHki9Uvv__"